"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _concat2 = _interopRequireDefault(require("lodash/concat"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _userflow = require("../../utils/userflow");
var _PreloadImage = _interopRequireDefault(require("../PreloadImage"));
var _PreloadIframe = _interopRequireDefault(require("../PreloadIframe/PreloadIframe"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 14.9L37 65l-21 50.1"
  }));
};
ArrowIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 53 130",
  fill: "none",
  stroke: "#fff",
  strokeWidth: "3",
  strokeLinecap: "round"
};
var FullscreenGallery = /*#__PURE__*/function (_React$PureComponent) {
  function FullscreenGallery(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, FullscreenGallery);
    _this = _callSuper(this, FullscreenGallery, [props]);
    var defaultIndex = props.defaultIndex;
    _this.state = {
      index: defaultIndex
    };

    // In case of SSR this shoud be placed in componentDidMount w/ rerender
    _this.events = (0, _userflow.makeTouchDependableEvents)();
    _this.handleCloseClick = _this.handleCloseClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(FullscreenGallery, _React$PureComponent);
  return (0, _createClass2["default"])(FullscreenGallery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.mounted = true;
      document.addEventListener('keydown', this.handleKeyDown);
      window.addEventListener('beforeunload', function () {
        _this2.hide();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "handleImageClick",
    value: function handleImageClick(i, e) {
      var _this3 = this;
      (0, _userflow.unlessLocked)(this, e, function () {
        _this3.changeIndex(i + 1);
      });
    }
  }, {
    key: "handleArrowClick",
    value: function handleArrowClick(d, e) {
      var _this4 = this;
      var index = this.state.index;
      (0, _userflow.unlessLocked)(this, e, function () {
        _this4.changeIndex(index + d);
      });
    }
  }, {
    key: "handleCloseClick",
    value: function handleCloseClick(e) {
      var _this5 = this;
      (0, _userflow.unlessLocked)(this, e, function () {
        return _this5.hide();
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      if (e.type === 'keydown' && this.mounted) {
        switch (e.keyCode) {
          case 37:
            this.handleArrowClick.call(this, -1, e);
            break;
          case 39:
            this.handleArrowClick.call(this, 1, e);
            break;
          case 27:
            this.handleCloseClick.call(this, e);
            break;
          default:
            break;
        }
      }
    }
  }, {
    key: "normalizeIndex",
    value: function normalizeIndex(index) {
      var nIndex;
      var items = this.props.items;
      var length = items.length - 1;
      if (index > length) {
        nIndex = 0;
      } else if (index < 0) {
        nIndex = length;
      } else {
        nIndex = Math.max(0, Math.min(index, length));
      }
      return nIndex;
    }
  }, {
    key: "hide",
    value: function hide() {
      var index = this.state.index;
      var onClose = this.props.onClose;
      onClose(index);
    }
  }, {
    key: "changeIndex",
    value: function changeIndex(i) {
      var prevIndex = this.state.index;
      var index = this.normalizeIndex(i);
      this.setState({
        index: index
      });
      var onChange = this.props.onChange;
      onChange({
        prevIndex: prevIndex,
        index: index
      });
    }
  }, {
    key: "renderImages",
    value: function renderImages() {
      var _this6 = this;
      var index = this.state.index;
      var _this$props = this.props,
        preload = _this$props.preload,
        items = _this$props.items;
      var endIndex = 1 + preload;
      var slicedImages = [];
      if (preload > index) {
        slicedImages = (0, _concat2["default"])(items.slice(-preload), items.slice(index, index + endIndex));
      } else {
        slicedImages = items.slice(index - preload, index + endIndex);
      }
      return slicedImages.map(function (item) {
        var images = item.images,
          special = item.special;
        var i = items.indexOf(item);
        var content = special.content;
        var src = (0, _userflow.getFullUrl)(images[_userflow.IMAGES_SIZE.FULL]);
        var props = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({
          key: src
        }, _this6.events.get('click'), _this6.handleImageClick.bind(_this6, i)), "style", i !== index ? {
          visibility: 'hidden',
          width: 0,
          height: 0,
          overflow: 'hidden',
          position: 'absolute'
        } : undefined);
        if (content) {
          return /*#__PURE__*/_react["default"].createElement(StyledImagesItem, props, /*#__PURE__*/_react["default"].createElement(_PreloadIframe["default"], {
            src: content
          }));
        }
        return /*#__PURE__*/_react["default"].createElement(StyledImagesItem, (0, _extends2["default"])({
          key: i
        }, props), /*#__PURE__*/_react["default"].createElement(_PreloadImage["default"], {
          src: src,
          showThrobber: true
        }));
      });
    }
  }, {
    key: "renderArrowButton",
    value: function renderArrowButton(direction) {
      var side = direction < 0 ? 'left' : 'right';
      var props = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, this.events.get('click'), this.handleArrowClick.bind(this, direction)), "side", side);
      return /*#__PURE__*/_react["default"].createElement(StyledControlsButton, props, /*#__PURE__*/_react["default"].createElement(ArrowIcon, null));
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var props = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, this.events.get('click'), this.handleCloseClick.bind(this)), "type", 'button');
      return /*#__PURE__*/_react["default"].createElement(StyledControls, null, /*#__PURE__*/_react["default"].createElement(StyledCloseBtn, props), this.renderArrowButton(-1), this.renderArrowButton(1));
    }
  }, {
    key: "renderCurrentTitle",
    value: function renderCurrentTitle() {
      var index = this.state.index;
      var items = this.props.items;
      var _ref = items[index].special || {},
        title = _ref.title;
      if (title) {
        return title;
      }
      return "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 ".concat(index + 1, " \u0438\u0437 ").concat(items.length);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(StyledModal, null, /*#__PURE__*/_react["default"].createElement(StyledGallery, null, this.renderControls(), /*#__PURE__*/_react["default"].createElement(StyledImageWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledImagesContainer, null, this.renderImages()), /*#__PURE__*/_react["default"].createElement(StyledCounter, null, this.renderCurrentTitle()))));
    }
  }]);
}(_react["default"].PureComponent);
FullscreenGallery.propTypes = {
  className: _propTypes["default"].string,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    images: _propTypes["default"].shape((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _userflow.IMAGES_SIZE.SMALL, _propTypes["default"].string), _userflow.IMAGES_SIZE.FULL, _propTypes["default"].string), _userflow.IMAGES_SIZE.BIG, _propTypes["default"].string.isRequired), _userflow.IMAGES_SIZE.BIG_X2, _propTypes["default"].string)).isRequired,
    special: _propTypes["default"].shape({
      id: _propTypes["default"].number,
      content: _propTypes["default"].string,
      title: _propTypes["default"].string
    }).isRequired
  })).isRequired,
  defaultIndex: _propTypes["default"].number,
  index: _propTypes["default"].number,
  preload: _propTypes["default"].number,
  onClose: _propTypes["default"].func,
  onChange: _propTypes["default"].func
};
FullscreenGallery.defaultProps = {
  className: '',
  defaultIndex: 0,
  index: 0,
  preload: 1,
  onClose: Function.prototype,
  onChange: Function.prototype
};
var StyledModal = (0, _styledComponents["default"])(_Modal["default"]).withConfig({
  displayName: "FullscreenGallery__StyledModal",
  componentId: "sc-wrp8nw-0"
})(["z-index:130000;"]);
var StyledGallery = _styledComponents["default"].div.withConfig({
  displayName: "FullscreenGallery__StyledGallery",
  componentId: "sc-wrp8nw-1"
})(["width:100%;height:100%;position:relative;"]);
var padding = 50;
var StyledImageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FullscreenGallery__StyledImageWrapper",
  componentId: "sc-wrp8nw-2"
})(["padding:", "px 0;position:relative;height:calc(100% - ", "px);box-sizing:content-box;"], padding, padding * 2);
var StyledImagesContainer = _styledComponents["default"].div.withConfig({
  displayName: "FullscreenGallery__StyledImagesContainer",
  componentId: "sc-wrp8nw-3"
})(["width:100%;margin:0 auto;white-space:nowrap;box-sizing:border-box;height:calc(100% - ", "px);"], padding);
var StyledControls = _styledComponents["default"].div.withConfig({
  displayName: "FullscreenGallery__StyledControls",
  componentId: "sc-wrp8nw-4"
})(["z-index:20;width:100%;height:0px;position:relative;"]);
var StyledControlsButton = _styledComponents["default"].button.withConfig({
  displayName: "FullscreenGallery__StyledControlsButton",
  componentId: "sc-wrp8nw-5"
})(["top:0;margin:0;padding:0;width:50px;height:100vh;outline:none;border:none;cursor:pointer;background:none;text-align:center;position:absolute;display:table-cell;vertical-align:middle;opacity:0.5;transition:opacity 120ms ease;:hover{opacity:1;}", ";"], function (props) {
  return "\n    ".concat(props.side, ": 0;\n    ").concat(props.side === 'left' ? 'transform: rotate(180deg);' : '', "\n  ");
});
var StyledCloseBtn = _styledComponents["default"].button.withConfig({
  displayName: "FullscreenGallery__StyledCloseBtn",
  componentId: "sc-wrp8nw-6"
})(["top:5px;margin:0;right:5px;z-index:5;padding:0;width:40px;color:", ";opacity:0.6;height:40px;border:none;outline:none;cursor:pointer;background:none;position:absolute;background-color:rgba(255,255,255,0.2);transition:opacity 120ms ease;::before,::after{height:2px;content:'';display:block;margin:0 auto;position:absolute;-webkit-transform-origin:50%;-moz-transform-origin:50%;transform-origin:50%;width:calc(100% - 10px);background-color:currentColor;left:calc((40px - (100% - 10px)) / 2);transform:rotate(45deg);}::after{transform:rotate(-45deg);}:hover{opacity:1;}"], function (props) {
  return props.theme.colors.white;
});
var StyledCounter = _styledComponents["default"].div.withConfig({
  displayName: "FullscreenGallery__StyledCounter",
  componentId: "sc-wrp8nw-7"
})(["color:", ";line-height:50px;height:50px;text-align:center;"], function (props) {
  return props.theme.colors.white;
});
var StyledImagesItem = _styledComponents["default"].div.withConfig({
  displayName: "FullscreenGallery__StyledImagesItem",
  componentId: "sc-wrp8nw-8"
})(["height:100%;margin:0 50px;display:flex;justify-content:center;align-items:center;width:calc(100% - 100px);"]);
var _default = exports["default"] = FullscreenGallery;